export const colorOptions: Record<string, string> = {
  Blue: "bg-blue-600 text-white border-blue-600",
  DodgerBlue: "bg-[#1E90FF] text-white border-[#1E90FF]",
  Green: "bg-green-600 text-white border-green-600",
  Red: "bg-red-600 text-white border-red-600",
  Purple: "bg-purple-600 text-white border-purple-600",
  Orange: "bg-orange-600 text-white border-orange-600",
  Pink: "bg-pink-600 text-white border-pink-600",
  Teal: "bg-teal-600 text-white border-teal-600",
  Yellow: "bg-yellow-600 text-black border-yellow-600",
  Indigo: "bg-indigo-600 text-white border-indigo-600",
  Cyan: "bg-cyan-600 text-black border-cyan-600",
  Amber: "bg-amber-600 text-black border-amber-600",
  Lime: "bg-lime-600 text-black border-lime-600",
  Fuchsia: "bg-fuchsia-600 text-black border-fuchsia-600",
  Sky: "bg-sky-600 text-white border-sky-600",
  Emerald: "bg-emerald-600 text-white border-emerald-600",
};
//  { color: "#1E90FF", name: "DodgerBlue" },

export const textColorOptions: Record<string, string> = {
  Blue: "text-blue-600",
  DodgerBlue: "text-[#1E90FF]",
  Green: "text-green-600",
  Red: "text-red-600",
  Purple: "text-purple-600",
  Orange: "text-orange-600",
  Pink: "text-pink-600",
  Teal: "text-teal-600",
  Yellow: "text-yellow-600",
  Indigo: "text-indigo-600",
  Cyan: "text-cyan-600",
  Amber: "text-amber-600",
  Lime: "text-lime-600",
  Fuchsia: "text-fuchsia-600",
  Sky: "text-sky-600",
  Emerald: "text-emerald-600",
};
export const borderHighlightOptions: Record<string, string> = {
  Blue: "border-blue-600 ring-blue-400",
  DodgerBlue: "border-[#1E90FF] ring-[#1E90FF]",
  Green: "border-green-600 ring-green-400",
  Red: "border-red-600 ring-red-400",
  Purple: "border-purple-600 ring-purple-400",
  Orange: "border-orange-600 ring-orange-400",
  Pink: "border-pink-600 ring-pink-400",
  Teal: "border-teal-600 ring-teal-400",
  Yellow: "border-yellow-600 ring-yellow-400",
  Indigo: "border-indigo-600 ring-indigo-400",
  Cyan: "border-cyan-600 ring-cyan-400",
  Amber: "border-amber-600 ring-amber-400",
  Lime: "border-lime-600 ring-lime-400",
  Fuchsia: "border-fuchsia-600 ring-fuchsia-400",
  Sky: "border-sky-600 ring-sky-400",
  Emerald: "border-emerald-600 ring-emerald-400",
};

export const fontOptions: Record<string, string> = {
  "Franklin Gothic Medium": "Franklin Gothic Medium",
  "Sans-serif": "font-sans",
  Serif: "font-serif",
  Monospace: "font-mono",
  Thin: "font-thin",
  "Extra Light": "font-extralight",
  Light: "font-light",
  Normal: "font-normal",
  Medium: "font-medium",
  "Semi Bold": "font-semibold",
  Bold: "font-bold",
  "Extra Bold": "font-extrabold",
  Black: "font-black",
  Italic: "italic",
  Uppercase: "uppercase",
  Lowercase: "lowercase",
  Capitalize: "capitalize",
  "Tracking Tight": "tracking-tight",
  "Tracking Wide": "tracking-wide",
  "Text Shadow": "shadow-lg",
  "Small Caps": "tracking-widest uppercase text-xs",
  "Loose Spacing": "tracking-wider",
};

export const defaultTheme = {
  background_color: colorOptions["DodgerBlue"],
  font_color: "white",
  font_family: fontOptions["Sans-serif"],
};
